<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-finance-body">
            <div class="dw-stat-grid">
                <div class="dw-stat-item" v-for="(item, i) in periods" :key="item.label">
                    <span class="dw-stat-label">{{ item.label }}</span>
                    <span class="dw-stat-value" :style="{ color: colors[i] }">{{ item.value }}</span>
                </div>
            </div>
            <div class="dw-sparkline-wrap">
                <apexchart type="area" height="90" :options="chartOpts" :series="chartSeries" />
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';
import { sparklineOpts, cssVar } from '../chartOpts';

export const meta = {
    id: 'revenue',
    titleKey: 'common.dashboard.widgetTitles.revenue',
    icon: 'bi-graph-up-arrow',
    accent: 'var(--bs-success)',
    accentBg: 'rgba(var(--bs-success-rgb, 80, 205, 137), 0.12)',
    glassRgb: '80, 205, 137',
    defaultCol: 1,
    defaultRow: 1,
    source: { type: 'statistics', key: 'revenue' },
};

function fmtTRY(n) {
    return (parseFloat(n) || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 });
}

export default {
    name: 'RevenueWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return { meta };
    },
    computed: {
        periods() {
            const d = this.apiData || {};
            return [
                { label: this.$t('common.dashboard.widgetLabels.periodToday'), value: fmtTRY(d.today) },
                { label: this.$t('common.dashboard.widgetLabels.periodWeek'), value: fmtTRY(d.this_week) },
                { label: this.$t('common.dashboard.widgetLabels.periodMonth'), value: fmtTRY(d.this_month) },
                { label: this.$t('common.dashboard.widgetLabels.periodTotal'), value: fmtTRY(d.total) },
            ];
        },
        sparkline() {
            const dt = this.apiData?.daily_totals;
            if (!dt) return [];
            return Object.values(dt).map(v => parseFloat(v) || 0);
        },
        colors() {
            return [
                cssVar('--bs-success', '#50CD89'),
                cssVar('--bs-info', '#7239EA'),
                '#3B82F6',
                'var(--bs-body-color)',
            ];
        },
        chartOpts() { return sparklineOpts(cssVar('--bs-success', '#50CD89')); },
        chartSeries() { return [{ data: this.sparkline }]; },
    },
};
</script>
